// global
import React from 'react';
import PropTypes from 'prop-types';
// assets
import SearchIcon from 'assets/icon/search-icon/SearchIcon';
import ProblemIcon from 'assets/icon/problem-icon/ProblemIcon';
// consts
import { COLORS } from 'app/config/colors';
// stylesheet
import styles from './SearchBox.module.scss';

// TODO #Autocomplete

function SearchBox(props) {
  const {
    onChange,
    onClick,
    value,
    label,
    placeholder,
    onKeyPress,
    size,
    error,
    showErrorMsg,
    message,
    disabled,
    inline,
    fullWidth
  } = props;

  const showError = () => {
    const { error: err /* , groupIndexes, repeated */ } = error;

    // const isRepetedQuestion = !!repeated;
    // if (isRepetedQuestion) {
    //   return err && (_.isEmpty(groupIndexes) || groupIndexes.includes(groupIndex));
    // }

    return err;
  };

  const variables = {
    '--direction': inline ? 'row' : 'column',
    '--align': inline ? 'center' : 'flex-start'
  };

  const style = () => {
    let style;

    if (disabled) {
      style = `${styles[size]} ${styles.disabled}`;
    } else if (showError()) {
      style = `${styles[size]} ${styles.error}`;
    } else if (value) {
      style = `${styles[size]} ${styles.value}`;
    } else {
      style = styles[size];
    }

    if (fullWidth) style += ` ${styles.fullWidth}`;

    return style;
  };

  const shouldShowError = showErrorMsg && showError();

  return (
    <div className={style()} style={variables}>
      <label>{label}</label>
      <div>
        <div className={styles.container}>
          <input
            className={styles.searchDefault}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            onKeyDown={onKeyPress}
            disabled={disabled}
          />
          {showError() && (
            <ProblemIcon fill={COLORS.ALERT_NEGATIVE} className={styles.problemIcon} />
          )}
          <button disabled={disabled} onClick={onClick}>
            <SearchIcon />
          </button>
        </div>
        {shouldShowError && <small className={styles.errorMessage}>{error.error}</small>}
        {!shouldShowError && message && <small className={styles.message}>{message}</small>}
      </div>
    </div>
  );
}

SearchBox.defaultProps = {
  label: 'Pesquisar',
  placeholder: 'Buscar...',
  size: 'medium',
  error: {
    error: null
    // groupIndexes: [],
    // repeated: false
  },
  showErrorMsg: true,
  inline: false,
  fullWidth: false
};

SearchBox.propTypes = {
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  value: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  popupSearchText: PropTypes.string,
  onKeyPress: PropTypes.func,
  size: PropTypes.oneOf(['small', 'medium', 'big', 'huge']),
  error: PropTypes.shape({
    error: PropTypes.string
    // groupIndexes: PropTypes.array,
    // repeated: PropTypes.bool
  }),
  showErrorMsg: PropTypes.bool,
  message: PropTypes.string,
  disabled: PropTypes.bool,
  inline: PropTypes.bool,
  fullWidth: PropTypes.bool
};

export default SearchBox;
